import React from 'react'
import {
  change as changeFieldValue, Field, formValueSelector, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';

import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import { renderFieldCep } from '../../util/inputs';

export const validate = (values) => {
  const erros = {};
  if (!values.cep) {
    erros.cep = 'Campo obrigatório'
  }
  if (!values.logradouro) {
    erros.logradouro = 'Campo obrigatório'
  }
  if (!values.complemento) {
    erros.complemento = 'Complemento obrigatório.'
  }

  if (!values.bairro) {
    erros.bairro = 'Bairro obrigatório.'
  }

  if (!values.uf) {
    erros.uf = 'UF obrigatório.'
  }

  return erros
};


const renderField = ({
  input,
  label,
  type,
  css,
  max,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             id={input.name}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);


export class ModalCadastrarEmpresa extends React.Component {
  constructor (props) {
    super(props);
    this.limparCampos = this.limparCampos.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);

    this.state = {
      mensagem: { tipo: '', texto: '' },
      usuario: null,
      tiposQualificacao: [],
    };
  }

  // eslint-disable-next-line
  pesquisarPorCep (event) {
    const CEP = event.target.value.replace(/\D/g, '')
    if (CEP.length === 8) {
      const url = `${URL}/cep/public/${CEP}`
      axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
        if (resp.status === 200) {
          this.props.changeFieldValue('formularioCadastroEmpresa',
            'logradouro', resp.data.logradouro);
          this.props.changeFieldValue('formularioCadastroEmpresa',
            'complemento', resp.data.complemento);
          this.props.changeFieldValue('formularioCadastroEmpresa',
            'bairro', resp.data.bairro);
          this.props.changeFieldValue('formularioCadastroEmpresa',
            'uf', resp.data.uf);
        }
      })
    }
    this.limparCampos()
  }

  limparCampos () {
    this.props.changeFieldValue('formularioCadastroEmpresa',
      'logradouro', '');
    this.props.changeFieldValue('formularioCadastroEmpresa',
      'complemento', '');
    this.props.changeFieldValue('formularioCadastroEmpresa',
      'bairro', '');
    this.props.changeFieldValue('formularioCadastroEmpresa',
      'uf', '');
  }


  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  recuperaMensagem () {
    if (this.state.mensagem !== null && this.state.mensagem !== undefined) {
      if (this.state.mensagem.tipo === 'sucesso') {
        return (
          <div className="alert alert-success col-md-12">
            {this.state.mensagem.texto}
            <button type="button" className="close" aria-label="Close"
                    onClick={() => {
                      this.limparMensagem();
                      this.setState({ usuario: null })
                    }
                    }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
      if (this.state.mensagem.tipo === 'erro') {
        return (
          <div className="alert alert-danger col-md-12">
            {this.state.mensagem.texto}
            <button type="button" className="close" aria-label="Close"
                    onClick={() => {
                      this.limparMensagem();
                    }
                    }>
              <i className="material-icons">
                &#xe5cd;
              </i>
            </button>
          </div>
        )
      }
    }
    return ''
  }

  limparFormulario () {
    this.props.reset('formularioCadastroEmpresa');
    this.limparMensagem();
    this.removerImagem();
  }

  render () {
    const {
      handleSubmit, submitting, invalid, paginaAnterior
    } = this.props;
    return (

      <div className="modal-body">
        {this.recuperaMensagem()}
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col-12 col-sm-4 col-md-4">
              <Field name="cep" type="text" component={renderFieldCep} label="CEP:"
                     css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
            </div>
          </div>
          <div className="form-row">
            <div className="col-12 col-sm-9 col-md-9">
              <Field name="logradouro" type="text" component={renderField} label="Logradouro:"
                     css="form-control" readOnly={false}/>
            </div>
          </div>
          <div className="form-row">
            <div className="col-12 col-sm-9 col-md-9">
              <Field name="complemento" type="text" component={renderField} label="Complemento:"
                     css="form-control" readOnly={false}/>
            </div>
            <div className="col-12 col-sm-9 col-md-3">
              <Field name="numero" type="text" component={renderField} label="Número:"
                     css="form-control" readOnly={false}/>
            </div>
          </div>
          <div className="form-row">
            <div className="col-12 mt-2">
              <label>Cidade:</label>
            </div>
            <SelecaoCidadeAutocomplete name='Informe nome da cidade'
                                       selecionarCidade={this.props.selecionarOrigem}
                                       value={this.props.cidade}
            />
          </div>
          <div className="form-row">
            <div className="col-12 col-sm-4 col-md-4">
              <Field name="bairro" type="text" component={renderField} label="Bairro:"
                     css="form-control" readOnly={false}/>
            </div>
          </div>

          <div className="form-group area-codigo">
            <Field name="idEndereco" type="hidden" component={renderField} css="form-control col-md-12"/>
          </div>
          <div className="modal-footer">

            <button className="btn btn-light" onClick={paginaAnterior}
            >Voltar
            </button>
            <button type="submit" disabled={invalid || submitting || !this.props.cidade}
                    className="btn btn-laranja" onClick={() => this.props.proximaPagina()}
            >Avançar
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export const mapStateToProps = state => (
  {
    cidadeForm: formValueSelector('formularioCadastroEmpresa')(state, 'cidadeForm'),
  });

export default connect(mapStateToProps,{changeFieldValue})(reduxForm({
  form: 'formularioCadastroEmpresa',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(ModalCadastrarEmpresa));
